import React, { useEffect, useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import { Link, useNavigate } from "react-router-dom";

import {
  Table,
  Input,
  Breadcrumb,
  Button,
  Space,
  Tooltip,
  Checkbox,
  Form,
  Select,
  Menu,
  Row,
  Col,
  DatePicker,
  Dropdown,
} from "antd";
import { debounce } from "lodash";
import { getRequest } from "../../axios";
import ButtonField from "../../common/htmlComponents/ButtonField";
import SearchIcon from "../../image/SearchIcon.svg";
import { ErrorNotificationMsg } from "../../utils/Notifications";
import "antd/dist/antd.min.css";
import "../../styles/Main.scss";

import moment from "moment";
import SelectRouteModal from "./SelectRouteModal";
import {
  InsertRowLeftOutlined,
  EyeOutlined,
  DownloadOutlined,
  UndoOutlined,
  FilterOutlined,
} from "@ant-design/icons";
import { useRouteNameChanges } from "../RouteNameProvider";
// import { tooltip } from "leaflet";
// import DriverAssignment from "./DriverAssignment";
// import AssignToDriver from "./AssignToDriver";
import PickupAssignToDriver from "./PickupAssignToDriver";

const { Option } = Select;
const PickupRoutelist = () => {
  const { t } = useTranslation();
  const [form] = Form.useForm();
  const [driverForm] = Form.useForm();
  const navigate = useNavigate();
  const { Search } = Input;
  const [selectedRow, setSelectedRow] = useState([]);
  const [loading, setLoading] = useState(false);
  const [reload, setReload] = useState(false);
  const [employeeList, setEmployeeList] = useState([]);
  const [totalCount, settotalCount] = useState(0);
  const [dropdownVisible, setDropdownVisible] = useState(false);

  // const { driverState, setDriverState } = useRouteNameChanges();

  const [startDate, setStartDate] = useState(null);
  const [driverList, setDriverList] = useState([]);

  const [isModalVisibleRoute, setIsModalVisibleRoute] = useState(false);

  const [selectedRecords, setSelectedRecords] = useState([]);

  const formRef = useRef();

  const [state, setState] = useState({
    page: 1,
    ordering: "id",
    pagesize: 10,
    search: "",
    total: 0,
  });
  const intialFilter = {
    // created_date: moment().format("DD-MM-YYYY"),
    created_date: "",
    driver_id: "",
    status: "",
  };
  const [stateFilter, setStateFilter] = useState(intialFilter);

  useEffect(() => {
    const getEmployeeList = async () => {
      setLoading(true);

      try {
        let apiResponse = await getRequest(
          `route/?created_date=${stateFilter?.created_date}&driver_id=${stateFilter?.driver_id}&status=${stateFilter?.status}`,
          state
        );

        if (apiResponse?.data?.results?.success) {
          setEmployeeList(apiResponse?.data?.results?.data);

          settotalCount(apiResponse.data.count);
        }
        setLoading(false);
      } catch (error) {
        ErrorNotificationMsg(t("Error fetching route list"));
      } finally {
        setLoading(false);
      }
    };

    getEmployeeList();
  }, [state, t, reload]);
  useEffect(() => {
    getDriverName();
  }, []);

  const handleDownload = async (id) => {
    if (!id) {
      console.error("No ID provided for downloading the CSV.");
      return;
    }

    try {
      // Construct the API endpoint using the id
      const endpoint = `route/${id}/route-csv-download/`;

      // Send a GET request to the endpoint
      const response = await getRequest(endpoint);

      // Process and download the CSV file
      const blob = new Blob([response.data], { type: "text/csv" });
      const link = document.createElement("a");
      link.href = window.URL.createObjectURL(blob);
      link.download = `Package_List_${Date.now()}.csv`;
      link.click();
      link.remove(); // Clean up the DOM element
    } catch (error) {
      if (error.response && error.response.status === 404) {
        console.error("File not found or endpoint is incorrect.");
        ErrorNotificationMsg(t("file_not_found"));
      } else {
        console.error("Error downloading the file:", error);
        ErrorNotificationMsg(t("error_downloading_file"));
      }
    }
  };

  const [checkedList, setCheckedList] = useState([
    "coordinates",
    "route_status",
    // "packages",
    "driver",
    "route_name",
    "start_street_address",
    "start_suburb",
    "start_state",
    "start_postcode",
    "start_additional_details",
    "end_street_address",
    "end_suburb",
    "end_postcode",
    "end_state",
    "end_postcode",
    "end_additional_details",
    "operation",
    "package_failed",
    "package_delivered",
    "package_loaded",
    // "package_in_transit",
  ]);

  const [columns, setColumns] = useState([]);

  const allColumns = [
    { key: "route_name", title: "Route Name" },
    { key: "package_loaded", title: "Status Loaded" },
    { key: "package_in_transit", title: "Status In Transit" },
    { key: "package_failed", title: "Status Failed" },
    { key: "package_delivered", title: "Status Delivered" },
    { key: "driver", title: "Driver Name" },
    { key: "start_street_address", title: "Start Street Address" },
    { key: "start_suburb", title: "Start Suburb" },

    { key: "start_state", title: "Start State" },
    { key: "start_postcode", title: "Start Postcode" },
    { key: "start_additional_details", title: "Start Additional Details" },
    { key: "end_street_address", title: "End Street Address" },
    { key: "end_suburb", title: "End Suburb" },

    { key: "end_state", title: "End State" },
    { key: "end_postcode", title: "End Postcode" },
    { key: "end_additional_details", title: "End Additional Details" },

    { key: "operation", title: "Action" },
  ];

  useEffect(() => {
    const updatedColumns = [
      {
        title: "Route Name",
        dataIndex: "route_name",
        key: "route_name",
        width: 300,
        sorter: true,
        render: (dataIndex) => (
          // <Tooltip
          //   color={colors}
          //   placement="left"
          //   title={<span style={{ color: "#fff" }}>{dataIndex}</span>}
          // >
          <div
            style={{
              maxWidth: "400px",
              whiteSpace: "nowrap",
              overflow: "hidden",
              textOverflow: "ellipsis",
              textTransform: "none",
            }}
          >
            {dataIndex}
          </div>
          // </Tooltip>
        ),
      },
      {
        title: "Assigned Driver",
        dataIndex: "driver_name",
        key: "driver",
        sorter: true,
        width: 190,
        render: (driver_name, record) => (
          <PickupAssignToDriver
            record={record}
            setReload={setReload}
            setState={setState}
            driverList={driverList}
            setEmployeeList={setEmployeeList}
          />
        ),
      },
      // {
      //   title: "Driver Name",
      //   dataIndex: "driver_name",
      //   key: "driver",
      //   sorter: true,
      //   width: 150,
      // },
      // {
      //   title: "Packages",
      //   dataIndex: "packages",
      //   key: "packages",
      //   sorter: true,
      //   width: 200,
      //   //render: (packages) => packages.join(", "), // If you want to list package IDs
      //   render: (packages) =>
      //     packages.map((packageItem) => packageItem.parcel_no).join(", "),
      // },
      {
        title: "Status Loaded",
        dataIndex: "package_loaded",
        key: "package_loaded",
        sorter: true,
        width: 150,
      },

      {
        title: "Status In Transit",
        dataIndex: "package_in_transit",
        key: "package_in_transit",
        sorter: true,
        width: 150,
      },
      {
        title: "Status Failed",
        dataIndex: "package_failed",
        key: "package_failed",
        sorter: true,
        width: 150,
      },
      {
        title: "Status Delivered",
        dataIndex: "package_delivered",
        key: "package_delivered",
        sorter: true,
        width: 150,
      },
      {
        title: "Route Status",
        dataIndex: "route_status",
        key: "route_status",
        sorter: true,
        width: 150,
      },

      {
        title: "Start Street Address",
        dataIndex: "start_street_address",
        key: "start_street_address",
        sorter: true,
        width: 200,
        render: (dataIndex) => (
          // <Tooltip
          //   color={colors}
          //   placement="left"
          //   title={<span style={{ color: "#fff" }}>{dataIndex}</span>}
          // >
          <div
            style={{
              maxWidth: "400px",
              whiteSpace: "nowrap",
              overflow: "hidden",
              textOverflow: "ellipsis",
            }}
          >
            {dataIndex}
          </div>
          // </Tooltip>
        ),
      },
      {
        title: "Start Suburb",
        dataIndex: "start_suburb",
        key: "start_suburb",
        sorter: true,
        width: 150,
      },

      {
        title: "Start State",
        dataIndex: "start_state",
        key: "start_state",
        sorter: true,
        width: 150,
      },
      {
        title: "Start Postcode",
        dataIndex: "start_postcode",
        key: "start_postcode",
        sorter: true,
        width: 150,
      },
      {
        title: "Start Additional Details",
        dataIndex: "start_additional_details",
        key: "start_additional_details",
        sorter: true,
        width: 200,
      },

      {
        title: "End Street Address",
        dataIndex: "end_street_address",
        key: "end_street_address",
        sorter: true,
        width: 200,
        render: (dataIndex) => (
          // <Tooltip
          //   color={colors}
          //   placement="left"
          //   title={<span style={{ color: "#fff" }}>{dataIndex}</span>}
          // >
          <div
            style={{
              maxWidth: "400px",
              whiteSpace: "nowrap",
              overflow: "hidden",
              textOverflow: "ellipsis",
            }}
          >
            {dataIndex}
          </div>
          // </Tooltip>
        ),
      },
      {
        title: "End Suburb",
        dataIndex: "end_suburb",
        key: "end_suburb",
        sorter: true,
        width: 150,
      },
      {
        title: "End State",
        dataIndex: "end_state",
        key: "end_state",
        sorter: true,
        width: 150,
      },
      {
        title: "End Postcode",
        dataIndex: "end_postcode",
        key: "end_postcode",
        sorter: true,
        width: 150,
      },
      {
        title: "End Additional Details",
        dataIndex: "end_additional_details",
        key: "end_additional_details",
        sorter: true,
        width: 200,
      },

      // {
      //   title: "Coordinates",
      //   key: "coordinates",
      //   sorter: true,
      //   width: 200,
      //   render: (record) => (
      //     <Tooltip
      //       color={colors}
      //       placement="left"
      //       title={<span style={{ color: "#fff" }}>{`Latitude: ${record?.coordinates?.latitude}, Longitude: ${record?.coordinates?.longitude}`}</span>}
      //     >

      //       <span>{`Latitude: ${record?.coordinates?.latitude}, Longitude: ${record?.coordinates?.longitude}`}</span>
      //     </Tooltip>
      //   )
      // },

      {
        title: "Action",
        key: "operation",
        sorter: true,
        fixed: "right",
        width: 100,
        render: (text, record) => (
          <Space>
            <Tooltip
              color={colors}
              placement="left"
              title={
                <span style={{ color: "#fff" }}>View the optimized route</span>
              }
            >
              <EyeOutlined onClick={() => handleRouteShow(record)} />
            </Tooltip>
            <Tooltip
              color={colors}
              placement="left"
              title={<span style={{ color: "#fff" }}>Download CSV</span>}
            >
              <DownloadOutlined onClick={() => handleDownload(record.id)} />
            </Tooltip>
          </Space>
        ),
      },
    ].filter((column) => checkedList.includes(column.key));
    setColumns(updatedColumns);
  }, [checkedList, driverList]);

  const handleColumnVisibilityChange = (checkedValues) => {
    setCheckedList(checkedValues);
  };
  const columnMenu = (
    <Menu className="packagelistdropdown">
      <Menu.Item>
        <Checkbox.Group
          value={checkedList}
          onChange={handleColumnVisibilityChange}
        >
          <Row>
            {allColumns.map((column) => (
              <Col span={12} key={column.key}>
                <Checkbox
                  value={column.key}
                  disabled={column.key === "operation"}
                >
                  {column.title}
                </Checkbox>
              </Col>
            ))}
          </Row>
        </Checkbox.Group>
      </Menu.Item>
    </Menu>
  );

  const getDriverName = async (driverId) => {
    try {
      const response = await getRequest("employee/drivers-list/");

      const { data } = response.data;

      setDriverList(data);
      formRef.current.setFieldsValue(response.data.data);

      // const filteredData = driverId ? data.filter(driver => driver.id === driverId) : data;
      // setDriverList(filteredData);

      // // If you need to set the form fields with the filtered driver
      // if (driverId) {
      //     const selectedDriver = filteredData[0]; // Assuming there's only one driver with that ID
      //     formRef.current.setFieldsValue(selectedDriver ? { driver_name: selectedDriver.name } : {});
      // }
      //  else {
      //     formRef.current.setFieldsValue(response.data.data);
      // }
    } catch (error) {
      console.log("");
    }
  };

  const handleDriverFilter = (value) => {
    setStateFilter((prevState) => ({
      ...prevState,
      driver_id: value,
    }));
  };
  const handleResidentSelectChange = (value) => {
    setStateFilter((prevState) => ({
      ...prevState,
      status: value,
    }));
  };

  const handleTableChange = async (pagination, filters, sorter, ordering) => {
    const orderBy = GetSortingEnumValue(sorter.columnKey, sorter.order);
    setState({
      ...state,
      page: pagination.current,
      pagesize: pagination.pageSize,
      ordering: orderBy,
    });

    if (selectedRow.length === 0) {
      driverForm.resetFields();
    }
    setSelectedRow(selectedRow);
  };

  const GetSortingEnumValue = (sortField, sortOrder) => {
    let sortingEnumKey = "id";

    if (sortField === "route_name" && sortOrder === "ascend") {
      sortingEnumKey = "route_name";
    }
    if (sortField === "route_name" && sortOrder === "descend") {
      sortingEnumKey = "-route_name";
    }
    if (sortField === "driver" && sortOrder === "ascend") {
      sortingEnumKey = "driver__name";
    }
    if (sortField === "driver" && sortOrder === "descend") {
      sortingEnumKey = "-driver__name";
    }
    if (sortField === "route_status" && sortOrder === "ascend") {
      sortingEnumKey = "route_status";
    }
    if (sortField === "route_status" && sortOrder === "descend") {
      sortingEnumKey = "-route_status";
    }

    if (sortField === "start_street_address" && sortOrder === "ascend") {
      sortingEnumKey = "start_street_address";
    }
    if (sortField === "start_street_address" && sortOrder === "descend") {
      sortingEnumKey = "-start_street_address";
    }

    if (sortField === "start_suburb" && sortOrder === "ascend") {
      sortingEnumKey = "start_suburb";
    }
    if (sortField === "start_suburb" && sortOrder === "descend") {
      sortingEnumKey = "-start_suburb";
    }

    if (sortField === "start_state" && sortOrder === "ascend") {
      sortingEnumKey = "start_state";
    }
    if (sortField === "start_state" && sortOrder === "descend") {
      sortingEnumKey = "-start_state";
    }

    if (sortField === "start_postcode" && sortOrder === "ascend") {
      sortingEnumKey = "start_postcode";
    }
    if (sortField === "start_postcode" && sortOrder === "descend") {
      sortingEnumKey = "-start_postcode";
    }
    if (sortField === "start_additional_details" && sortOrder === "ascend") {
      sortingEnumKey = "start_additional_details";
    }
    if (sortField === "start_additional_details" && sortOrder === "descend") {
      sortingEnumKey = "-start_additional_details";
    }
    if (sortField === "end_street_address" && sortOrder === "ascend") {
      sortingEnumKey = "end_street_address";
    }
    if (sortField === "end_street_address" && sortOrder === "descend") {
      sortingEnumKey = "-end_street_address";
    }
    if (sortField === "end_suburb" && sortOrder === "ascend") {
      sortingEnumKey = "end_suburb";
    }
    if (sortField === "end_suburb" && sortOrder === "descend") {
      sortingEnumKey = "-end_suburb";
    }
    if (sortField === "end_state" && sortOrder === "ascend") {
      sortingEnumKey = "end_state";
    }
    if (sortField === "end_state" && sortOrder === "descend") {
      sortingEnumKey = "-end_state";
    }
    if (sortField === "end_postcode" && sortOrder === "ascend") {
      sortingEnumKey = "end_postcode";
    }
    if (sortField === "end_postcode" && sortOrder === "descend") {
      sortingEnumKey = "-end_postcode";
    }
    if (sortField === "end_additional_details" && sortOrder === "ascend") {
      sortingEnumKey = "end_additional_details";
    }
    if (sortField === "end_additional_details" && sortOrder === "descend") {
      sortingEnumKey = "-end_additional_details";
    }
    if (sortField === "packages" && sortOrder === "ascend") {
      sortingEnumKey = "Packages";
    }
    if (sortField === "packages" && sortOrder === "descend") {
      sortingEnumKey = "-Packages";
    }
    if (sortField === "Coordinates" && sortOrder === "ascend") {
      sortingEnumKey = "Coordinates";
    }
    if (sortField === "Coordinates" && sortOrder === "descend") {
      sortingEnumKey = "-Coordinates";
    }
    return sortingEnumKey;
  };

  const handleReset = () => {
    setState({
      ...state,
      search: "",
    });

    form.setFieldsValue({ search: "" });
  };

  const handleApplyFilter = async () => {
    setState({
      page: 1,
      ordering: "id",
      pagesize: 10,
      search: "",
      total: 0,
    });
  };
  // const handleStartDateChange = (date) => {

  //   const formattedDate = moment(date).format("DD-MM-YYYY");
  //   setStartDate(formattedDate);
  //   setStateFilter((prevState) => ({
  //     ...prevState,
  //     created_date: formattedDate,
  //   }));
  // };
  const handleStartDateChange = (date, dateString) => {
    if (!date) {
      // If date is cleared, set created_date to null
      setStateFilter((prevState) => ({
        ...prevState,
        created_date: null,
      }));
    } else {
      const formattedDate = moment(date).format("DD-MM-YYYY");
      setStartDate(formattedDate);
      setStateFilter((prevState) => ({
        ...prevState,
        created_date: formattedDate,
      }));
    }
  };

  const handleResetFilter = () => {
    setState({
      // ...state,
      page: 1,
      ordering: "id",
      pagesize: 10,
      search: "",
      total: 0,
    });
    setStateFilter({
      created_date: "",
      driver_id: "",
      status: "",
    });

    form.setFieldsValue({ search: "" });
    setStartDate(null);

    formRef.current.setFieldsValue({
      state: undefined, // Set to undefined to keep placeholder
      zone: undefined, // Set to undefined to keep placeholder
      // zone: undefined,   // Set to undefined to keep placeholder
      suburb: undefined, // Set to undefined to keep placeholder
      created_date: "",
      driver_id: undefined,
      status: undefined,
    });
  };
  const searchCallbackDelayed = (event) => {
    const { value } = event.target;
    debounceLoadData(value, onSearch);
  };

  const onSearch = (value) => {
    setState({
      ...state,
      search: value,
    });
  };

  const debounceLoadData = debounce((value, onSearch) => {
    onSearch(value);
  }, 1000);

  const rowSelection = {
    onChange: (selectedRowKeys, selectedRows) => {
      if (selectedRowKeys.length === 0) {
        driverForm.resetFields();
      }
    },
    onSelect: (record, selected, selectedRows) => {
      const updatedSelectedRowKeys = selected
        ? [...selectedRow, record.id]
        : selectedRow?.filter((key) => key !== record.id);
      setSelectedRow(updatedSelectedRowKeys);
      setSelectedRecords(selectedRows);

      if (updatedSelectedRowKeys?.length === 0) {
        driverForm.resetFields();
      }
    },
    onSelectAll: (selected, selectedRows, changeRows) => {
      const updatedSelectedRowKeys = selected
        ? [...selectedRow, ...changeRows.map((row) => row.id)]
        : selectedRow?.filter(
            (key) => !changeRows.find((row) => row.id === key)
          );
      setSelectedRow(updatedSelectedRowKeys);
      setSelectedRecords(selectedRows);

      if (updatedSelectedRowKeys?.length === 0) {
        driverForm.resetFields();
      }
    },
    selectedRowKeys: selectedRow,
  };

  const handleRouteShow = (record) => {
    // setDriverState((prevState) => ({
    //   ...prevState,
    //   driver: record?.driver,
    //   route_name: record?.id,
    // }));
    navigate("/optimized-route");
  };

  const colors = ["#737373"];
  return (
    <>
      <section className="grid-sec">
        <div className="ListingTopBar">
          <div className="pagenamewrap">
            <div className="pagename">
              {/* <Tooltip
                color={colors}
                placement="right"
                title={
                  <span style={{ color: "#fff" }}>
                    View & Manage The List Of Route Within The Organization.
                  </span>
                }
              > */}
              <h3>{t("Pickup Route List")}</h3>
              {/* </Tooltip> */}

              <Breadcrumb className="Breadcrumb-Sec">
                <Breadcrumb.Item>
                  <Link to="/dashboard">{t("home")}</Link>
                </Breadcrumb.Item>
                <Breadcrumb.Item>{t("Pickup Route List")}</Breadcrumb.Item>
              </Breadcrumb>
            </div>
            <Space>
              <div className="searchwrp">
                <Space direction="vertical">
                  <Form form={form}>
                    <Form.Item name="search" initialValue="">
                      <Search
                        prefix={
                          <img
                            src={SearchIcon}
                            alt="SearchIcon"
                            className="SearchIcon"
                            width={22}
                          />
                        }
                        placeholder={t("pl_search_list")}
                        onChange={searchCallbackDelayed}
                      />
                    </Form.Item>
                  </Form>
                </Space>
              </div>
              {state?.search ? (
                // <Tooltip title="Reset search">
                <Button
                  className="BlueShadowBtn"
                  type="primary"
                  htmlType="button"
                  onClick={() => handleReset()}
                >
                  <span
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: "5px",
                    }}
                  >
                    <UndoOutlined style={{ fontSize: "16px", color: "#fff" }} />{" "}
                    Reset
                  </span>
                </Button>
              ) : (
                // </Tooltip>
                ""
              )}

              <div className="gridiconswrap">
                {/* <Tooltip placement="topLeft" title="Column Filter Options"> */}
                <Dropdown
                  overlay={columnMenu}
                  trigger={["click"]}
                  placement="bottomRight"
                  visible={dropdownVisible}
                  onVisibleChange={(visible) => setDropdownVisible(visible)}
                >
                  <Button
                    type="primary"
                    shape="circle"
                    icon={<InsertRowLeftOutlined />}
                    onClick={() => setDropdownVisible(!dropdownVisible)}
                  />
                </Dropdown>
                {/* </Tooltip> */}
              </div>
            </Space>
          </div>
        </div>

        <div className="Package-body">
          <div className="filterrow packagefilter">
            <div className="filtercol">
              <Form autoComplete="off" ref={formRef}>
                <Space wrap>
                  <Col
                    xs={24}
                    sm={24}
                    md={24}
                    lg={24}
                    xl={24}
                    className="TextFeild gutter-row"
                  >
                    <Form.Item name="created_date" label={t("Created Date")}>
                      <DatePicker
                        format="DD-MM-YYYY"
                        showTime={false}
                        placeholder={t("Select Date")}
                        allowClear={false}
                        // defaultValue={moment()}
                        // onChange={(date, dateString) =>
                        //   handleStartDateChange(date, dateString)
                        // }
                        onChange={handleStartDateChange}
                        style={{ width: "140px" }}
                      />
                    </Form.Item>
                  </Col>

                  <Col
                    xs={24}
                    sm={24}
                    md={24}
                    lg={24}
                    xl={24}
                    className="TextFeild gutter-row"
                  >
                    <Form.Item name="driver_id" label={t("pl_driver")}>
                      <Select
                        placeholder={t("val_driver")}
                        showArrow
                        showSearch
                        style={{ width: "170px" }}
                        name="driver_id"
                        optionFilterProp="children"
                        onChange={(value) => handleDriverFilter(value)}
                      >
                        {driverList?.map((item) => (
                          <Option key={item.id} value={item.id}>
                            {item.name}
                          </Option>
                        ))}
                      </Select>
                    </Form.Item>
                  </Col>
                  <Col
                    xs={24}
                    sm={24}
                    md={24}
                    lg={24}
                    xl={24}
                    className="TextFeild gutter-row"
                  >
                    <Form.Item
                      name="status"
                      label={t("label_status")}
                      value={state?.status}
                    >
                      <Select
                        showArrow
                        placeholder={t("pl_select_status")}
                        onChange={(value) => handleResidentSelectChange(value)}
                      >
                        <Option key="Started" value="Started">
                          Started
                        </Option>
                        <Option key="In Transit" value="In Transit">
                          In Transit
                        </Option>
                        <Option key="End Route" value="End Route">
                          End Route
                        </Option>
                      </Select>
                    </Form.Item>
                  </Col>
                </Space>
              </Form>
            </div>
            <div className="btnscol btncolpack">
              <Space className="btnpack">
                <>
                  {/* <Tooltip title="Apply Filter"> */}
                  <span>
                    <ButtonField
                      className="SaveGradiantBtn"
                      type="primary"
                      htmlType="Apply"
                      label={
                        <span
                          style={{
                            display: "flex",
                            alignItems: "center",
                            gap: "5px",
                          }}
                        >
                          <FilterOutlined style={{ fontSize: "16px" }} /> Apply
                          Filter
                        </span>
                      }
                      onClick={handleApplyFilter}
                    />
                  </span>
                  {/* </Tooltip> */}
                  {startDate ||
                  stateFilter?.created_date ||
                  stateFilter?.status ||
                  stateFilter?.driver_id ? (
                    // <Tooltip title="Reset Filter">
                    <ButtonField
                      className="SaveGradiantBtn"
                      type="primary"
                      htmlType="button"
                      label={
                        <span
                          style={{
                            display: "flex",
                            alignItems: "center",
                            gap: "5px",
                          }}
                        >
                          <UndoOutlined
                            style={{ fontSize: "16px", color: "#fff" }}
                          />{" "}
                          Reset
                        </span>
                      }
                      onClick={handleResetFilter}
                    />
                  ) : (
                    // </Tooltip>
                    ""
                  )}
                </>
                {/* ) : (
                  ""
                )} */}
              </Space>
            </div>
            <div className="btnscol-route btncolpack">
              <SelectRouteModal
                parcels={selectedRecords}
                isModalVisible={isModalVisibleRoute}
                selectedRow={selectedRow}
                setIsModalVisible={setIsModalVisibleRoute}
                setState={setState}
              />
            </div>
          </div>

          <Table
            scroll={{
              x: 3000,
            }}
            rowSelection={rowSelection}
            rowKey={(record) => record.id}
            columns={columns.filter((col) => !col.hidden)}
            dataSource={employeeList}
            loading={loading}
            pagination={{
              defaultCurrent: state.page,
              defaultPageSize: state.pagesize,
              total: totalCount,
              showTotal: (total) => `Total ${total} items`,
              showSizeChanger: true,
              locale: {
                items_per_page: "Items / Page",
              },
            }}
            onChange={handleTableChange}
          />
        </div>
      </section>
    </>
  );
};
export default PickupRoutelist;
